/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Entityfilterid2Inputs */

const en_entity_entityfilterid2 = /** @type {(inputs: Entity_Entityfilterid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity Filter ID`)
};

const de_entity_entityfilterid2 = /** @type {(inputs: Entity_Entityfilterid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitätenfilter-ID`)
};

/**
* | output |
* | --- |
* | "Entity Filter ID" |
*
* @param {Entity_Entityfilterid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_entityfilterid2 = /** @type {((inputs?: Entity_Entityfilterid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Entityfilterid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_entityfilterid2(inputs)
	return de_entity_entityfilterid2(inputs)
});
export { entity_entityfilterid2 as "entity_entityFilterId" }